import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-candidate-home',
  templateUrl: './candidate-home.component.html',
  styleUrls: ['./candidate-home.component.css']
})
export class CandidateHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
